import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from 'axios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';

class OrganisationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      companyId: '',
      companyName: '',
      companyContact: '',
      companyAddress: '',
      companyCode: '',
      details: {},
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    if (event.target.name === 'companyName' && !this.props.data.isEdit) {
      let companyCode = this.formatStr(event.target.value);
      this.setState({
        companyCode,
      });
    }
  };

  formatStr(str) {
    if (str === undefined || str === null) {
      return;
    }
    str = str.replace(/ /g, '_');
    return str;
  }

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');

    if (!this.props.data.isEdit) {
      const data = {
        session_key: user.session_key,
        CompanyName: this.state.companyName,
        CompanyContact: this.state.companyContact,
        CompanyAddress: this.state.companyAddress,
        CompanyCode: this.state.companyCode,
      };

      axios
        .post(url + ':3000/v1/company/create', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }

          this.props.closeModal(
            <MdDone />,
            'New company added successfully.',
            'success',
            false,
          );
        })
        .catch(error => {
          alert(error);
        });
    } else {
      const data = {
        session_key: user.session_key,
        CompanyID: this.state.companyId,
        CompanyName: this.state.companyName,
        CompanyContact: this.state.companyContact,
        CompanyAddress: this.state.companyAddress,
        CompanyCode: this.state.companyCode,
      };

      axios
        .post(url + ':3000/v1/company/update', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }

          if (this.state.companyId === selected_org.CompanyID) {
            let updated = {
              CompanyID: this.state.companyId,
              CompanyAddress: this.state.companyAddress,
              CompanyContact: this.state.companyContact,
              CompanyName: this.state.companyName,
              Role: selected_org.Role,
              Features: result.data.Features,
              CompanyLogo: result.data.CompanyLogo,
              CompanyCode: this.state.companyCode,
              Has_Store: selected_org.Has_Store,
            };

            StorageService.setSession('selected_org', updated);
          }

          this.props.closeModal(
            <MdDone />,
            'Company details updated successfully.',
            'success', //'error' post when return error
            true,
          );
        })
        .catch(error => {
          alert(error);
        });
    }
  };

  getCompanyDetails = id => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      CompanyID: id,
    };

    axios
      .post(url + ':3000/v1/company/edit', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          details: result.data,
          companyId: id,
          companyName: result.data.CompanyName,
          companyContact: result.data.CompanyContact,
          companyAddress: result.data.CompanyAddress,
          companyCode: result.data.CompanyCode,
        });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    if (this.props.data.isEdit) {
      let id = this.props.data.selectedCompanyId;
      this.getCompanyDetails(id);
    }
  }

  render() {
    const { companyId } = this.state;
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal(null, companyId)}>
          Company Details
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="companyName">Company Name</Label>
                <Input
                  type="text"
                  name="companyName"
                  value={this.state.companyName}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="companyContact">Company Contact</Label>
                <Input
                  type="text"
                  name="companyContact"
                  value={this.state.companyContact}
                  onChange={this.changeHandler}
                />
              </FormGroup>
              <FormGroup>
                <Label for="companyAddress">Company Address</Label>
                <Input
                  type="textarea"
                  name="companyAddress"
                  value={this.state.companyAddress}
                  onChange={this.changeHandler}
                />
              </FormGroup>
              <FormGroup>
                <Label for="companyCode">Company Code</Label>
                <Input
                  type="text"
                  name="companyCode"
                  value={this.formatStr(this.state.companyCode)}
                  onChange={this.changeHandler}
                  required
                  disabled={this.props.data.isEdit ? true : false}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal(null, companyId)}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default OrganisationForm;
